//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EspecialidadAPI from '@/api/promotores/cursos/especialidades.api'
export default {
  props: {
    especialidad: {
      type: Object,
      default() {
        return {
          nombre: null,
          portada: null,
        };
      },
    },
  },

  data() {
    return {
      especialidad_: { ...this.especialidad },
      portada: null,
			loading: false,
    };
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    inputPortada(file) {
      this.especialidad_.portada = URL.createObjectURL(file)
    },

    async submit() {
			try {
				this.loading = true

        let payload = {
          nombre: this.especialidad_.nombre
        }

        if (this.especialidad_.id) {
          payload.id = this.especialidad_.id
        }

        if (this.portada) {
          payload.portada = this.portada
        }

				const especialidad = await EspecialidadAPI.save(payload)

				this.$emit('ok', especialidad)
				this.hide()
			} finally {
				this.loading = false
			}
		},
  },
};
